import React from 'react';
import { Alert, Space, Tag, Typography } from 'antd';
import type { CorrectionContext } from '../hooks/useCorrectionContext';

const { Text } = Typography;

const BAND_LABELS: Record<string, string> = {
  COMPLETED: 'Выполнено',
  CURRENT: 'Текущая',
  FUTURE: 'Будущая'
};

const BAND_COLORS: Record<string, string> = {
  COMPLETED: 'green',
  CURRENT: 'processing',
  FUTURE: 'blue'
};

type Props = {
  ctx: CorrectionContext;
  stopLabels: Map<number, string>;
};

export function CorrectionContextPanel({ ctx, stopLabels }: Props) {
  const { correction } = ctx;
  const otherAdvisories = correction.advisories.filter((a) => a.code !== 'PENALTY_AT_COMPLETION');

  return (
    <div className="mutation-workspace__section">
      <div className="mutation-workspace__section-title">Контекст исполнения</div>

      <Space wrap style={{ marginBottom: 12 }}>
        {correction.executionLock.inTransit && <Tag color="orange">В пути</Tag>}
        {correction.executionLock.executionComplete && <Tag color="green">Исполнение завершено</Tag>}
        {correction.isCompletionLocked && <Tag>Завершение зафиксировано</Tag>}
        {correction.isTerminalRoute && <Tag color="default">Терминальный статус</Tag>}
      </Space>

      {correction.executionLock.activeExecutionStopId != null && (
        <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
          Активная точка:{' '}
          {stopLabels.get(correction.executionLock.activeExecutionStopId) ??
            `#${correction.executionLock.activeExecutionStopId}`}
        </Text>
      )}

      <div className="mutation-workspace__section-title" style={{ marginTop: 16 }}>
        Лента точек
      </div>
      <div className="mutation-workspace__executed-list">
        {correction.stopBands.map((band) => (
          <div key={band.stopId} className="mutation-workspace__stop-row">
            <Space>
              <Tag color={BAND_COLORS[band.band]}>{BAND_LABELS[band.band]}</Tag>
              <Text>{stopLabels.get(band.stopId) ?? `Точка #${band.stopId}`}</Text>
              {band.editable && <Tag>редактируемая</Tag>}
            </Space>
          </div>
        ))}
      </div>

      {otherAdvisories.map((a) => (
        <Alert
          key={a.code}
          type={a.severity === 'warn' ? 'warning' : 'info'}
          showIcon
          message={a.message}
          style={{ marginTop: 12 }}
        />
      ))}
    </div>
  );
}
